const AUTHORIZATION_QUERY_KEYS = Object.freeze([
  'apiKey',
  'version',
  'deviceId',
  'oculusOrgId',
  'oculusAccessToken',
])

const PUBLIC_ROUTES = new Set([
  '/',
  '/youtube',
  '/users/auth/oculus/callback',
  '/users/auth/youtube/callback',
  '/_error',
])

function resolveAppAuthorization(router) {
  if (PUBLIC_ROUTES.has(router?.route)) {
    return {
      authorizationParams: null,
      shouldRenderRoute: true,
    }
  }

  if (!router?.isReady) {
    return {
      authorizationParams: null,
      shouldRenderRoute: false,
    }
  }

  const query = router.query || {}
  const authorizationValues = AUTHORIZATION_QUERY_KEYS.map((key) => query[key])
  const hasCompleteAuthorization = authorizationValues.every(
    (value) => typeof value === 'string' && value.length > 0
  )

  if (!hasCompleteAuthorization) {
    return {
      authorizationParams: null,
      shouldRenderRoute: false,
    }
  }

  return {
    authorizationParams: AUTHORIZATION_QUERY_KEYS
      .map((key, index) => `${key}=${authorizationValues[index]}`)
      .join('&'),
    shouldRenderRoute: true,
  }
}

module.exports = {
  resolveAppAuthorization,
}
